import { svgIconFactory } from './icon-factory';

function Icon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.01" width="20" height="20" fill="black" />
      <path
        d="M18.3543 15.3474C15.5315 14.2589 12.4043 12.904 12.1456 12.059V11.176C12.7755 10.4948 13.2276 9.66857 13.4619 8.77064C13.6222 8.65669 13.7573 8.51092 13.8587 8.34242C13.9601 8.17392 14.0257 7.98632 14.0514 7.79131C14.0771 7.59631 14.0623 7.3981 14.008 7.20905C13.9537 7.02001 13.8611 6.8442 13.7359 6.69258V4.69062C13.7359 2.6506 12.6022 1.25 10 1.25C7.39783 1.25 6.2641 2.6506 6.2641 4.69062V6.66975C6.13886 6.82136 6.04616 6.99718 5.99187 7.18622C5.93758 7.37526 5.92289 7.57348 5.94859 7.76848C5.9743 7.96348 6.0399 8.15109 6.14132 8.31959C6.24274 8.48809 6.37776 8.63386 6.53801 8.74781C6.76932 9.64691 7.22182 10.4738 7.8543 11.1532V12.0362C7.5956 12.8811 4.46849 14.2361 1.64567 15.3246C1.5288 15.3717 1.42862 15.4526 1.35811 15.5571C1.28761 15.6615 1.24999 15.7847 1.25 15.9107V18.1258C1.24999 18.29 1.31463 18.4477 1.43 18.5645C1.54537 18.6813 1.70211 18.748 1.86626 18.75H18.1337C18.2978 18.748 18.4545 18.6813 18.5699 18.5645C18.6853 18.4477 18.75 18.29 18.75 18.1258V15.9107C18.7456 15.7886 18.7058 15.6704 18.6356 15.5704C18.5653 15.4704 18.4677 15.393 18.3543 15.3474Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
      <defs>
        <linearGradient
          id="paint0_linear_659_2810"
          x1="18.4375"
          y1="18.75"
          x2="1.25132"
          y2="1.2487"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0050" />
          <stop offset="0.714448" stopColor="#7000FF" />
          <stop offset="1" stopColor="#0027FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const AccountIcon = svgIconFactory(Icon);
